import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/pre-registration/components/PreRegistrationPage.tsx");
